<div class="z-[999] fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-xs">
    <div class="absolute w-[766px] h-[570px] 2xl:h-[700px] bg-white rounded-xl shadow-xl overflow-hidden text-[0.8rem] 2xl:text-[0.9rem] flex flex-col">
        <!-- Header -->
        <div class="pt-4 flex-shrink-0">
            <div class="border-b-2 border-b-gray-100 h-10 mb-5">
                <h1 class="pl-4 text-[1em] 2xl:text-[1.2em] font-bold text-dimot-3 mb-2 2xl:mb-5">
                    Aggiungi Widget alla tua Dashboard
                </h1>
                <button
                    (click)="closeModal()"
                    class="absolute top-3 right-3 2xl:top-4 2xl:right-4 text-gray-500 hover:text-black text-sm 2xl:text-base cursor-pointer">
                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.4375 21.5625L21.5625 8.4375M21.5625 21.5625L8.4375 8.4375" stroke="#6B7280" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>

        <!-- scrolling area -->
         <!-- TO ADD THE OVERFLOW-Y-AUTO WHEN WE HAVE MORE WIDGETS -->
        <div class="flex-1 overflow-y-auto scrollbar px-4">
            <div class="flex flex-wrap w-full gap-2 pb-4">
                <div *ngFor="let widget of widgets">
                    <div class="relative flex flex-col items-start mb-4 rounded-md pb-2 px-4 min-w-[231px] cursor-pointer transition-all border-2"
                         [ngClass]="{
                           'border-[2px] border-dimot-1': isSelected(widget),
                           'border-gray-100': !isSelected(widget)
                         }">
                        
                        <!-- Overlay -->
                        <div *ngIf="widget.onDashboard"
                            class="absolute inset-0 bg-white/5 cursor-not-allowed rounded z-50 flex items-center justify-center" 
                            style="backdrop-filter: blur(1px);">
                            <div class="w-44 h-10 bg-[#EAEDF1] rounded-md text-dimot-1 flex items-center justify-center">
                                <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.1004 5.94935V10.9996L13.8881 14.7872M18.307 10.9996C18.307 13.1761 17.4424 15.2635 15.9033 16.8025C14.3643 18.3415 12.2769 19.2062 10.1004 19.2062C7.92387 19.2062 5.83649 18.3415 4.29746 16.8025C2.75842 15.2635 1.8938 13.1761 1.8938 10.9996C1.8938 8.82304 2.75842 6.73566 4.29746 5.19663C5.83649 3.65759 7.92387 2.79297 10.1004 2.79297C12.2769 2.79297 14.3643 3.65759 15.9033 5.19663C17.4424 6.73566 18.307 8.82304 18.307 10.9996Z" stroke="#141F58" stroke-width="0.631277"/>
                                </svg>
                                <h5 class="text-[0.94em] ml-2">Attualmente in uso</h5>
                            </div>
                        </div>
                        
                        <!-- Under overlay -->
                        <div (click)="toggleWidget(widget)">
                            <h3 class="font-semibold text-dimot-1 text-[0.6em] mt-2 mb-4">
                                {{ widget.name }}
                            </h3>                  
                            <div [ngClass]="widget.className"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
        <div class="text-center mt-3 2xl:mt-2 flex flex-col items-center justify-center gap-2 py-4 flex-shrink-0">
            <span class="text-[0.8em] 2xl:text-[1em] text-dimot-1">
                Hai selezionato <span class="font-bold">{{ selectedWidgets.length }}</span> widget
            </span>
          <button
    (click)="addWidgetsToDashboard()"
    [disabled]="selectedWidgets.length === 0"
    class="group border border-dimot-1 bg-dimot-1 text-white w-50 h-8 2xl:w-52 2xl:h-9 cursor-pointer rounded-md flex flex-row justify-center gap-2 items-center
           disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-dimot-1 disabled:hover:text-white
           hover:bg-white hover:text-dimot-1 transition-colors">
    <span class="text-[0.8em] 2xl:text-[0.82em]">Aggiungi alla Dashboard</span>
    
    <svg
        width="14"
        height="14"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="group-hover:hidden group-disabled:block"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.0213 16.5211C11.9643 16.5211 13.8277 15.7493 15.2016 14.3754C16.5755 13.0015 17.3473 11.1381 17.3473 9.19514C17.3473 7.25216 16.5755 5.38877 15.2016 4.01488C13.8277 2.64098 11.9643 1.86914 10.0213 1.86914C8.07834 1.86914 6.21494 2.64098 4.84105 4.01488C3.46716 5.38877 2.69531 7.25216 2.69531 9.19514C2.69531 11.1381 3.46716 13.0015 4.84105 14.3754C6.21494 15.7493 8.07834 16.5211 10.0213 16.5211ZM10.9371 6.44789C10.9371 6.20502 10.8406 5.97209 10.6688 5.80036C10.4971 5.62862 10.2642 5.53214 10.0213 5.53214C9.77844 5.53214 9.54552 5.62862 9.37378 5.80036C9.20204 5.97209 9.10556 6.20502 9.10556 6.44789V8.27939H7.27406C7.03119 8.27939 6.79827 8.37587 6.62653 8.54761C6.45479 8.71934 6.35831 8.95227 6.35831 9.19514C6.35831 9.43801 6.45479 9.67094 6.62653 9.84267C6.79827 10.0144 7.03119 10.1109 7.27406 10.1109H9.10556V11.9424C9.10556 12.1853 9.20204 12.4182 9.37378 12.5899C9.54552 12.7617 9.77844 12.8581 10.0213 12.8581C10.2642 12.8581 10.4971 12.7617 10.6688 12.5899C10.8406 12.4182 10.9371 12.1853 10.9371 11.9424V10.1109H12.7686C13.0114 10.1109 13.2444 10.0144 13.4161 9.84267C13.5878 9.67094 13.6843 9.43801 13.6843 9.19514C13.6843 8.95227 13.5878 8.71934 13.4161 8.54761C13.2444 8.37587 13.0114 8.27939 12.7686 8.27939H10.9371V6.44789Z"
            fill="currentColor"
        />
    </svg>

    <svg
        width="14"
        height="14"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="hidden group-hover:block group-disabled:hidden"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.0213 16.5211C11.9643 16.5211 13.8277 15.7493 15.2016 14.3754C16.5755 13.0015 17.3473 11.1381 17.3473 9.19514C17.3473 7.25216 16.5755 5.38877 15.2016 4.01488C13.8277 2.64098 11.9643 1.86914 10.0213 1.86914C8.07834 1.86914 6.21494 2.64098 4.84105 4.01488C3.46716 5.38877 2.69531 7.25216 2.69531 9.19514C2.69531 11.1381 3.46716 13.0015 4.84105 14.3754C6.21494 15.7493 8.07834 16.5211 10.0213 16.5211ZM10.9371 6.44789C10.9371 6.20502 10.8406 5.97209 10.6688 5.80036C10.4971 5.62862 10.2642 5.53214 10.0213 5.53214C9.77844 5.53214 9.54552 5.62862 9.37378 5.80036C9.20204 5.97209 9.10556 6.20502 9.10556 6.44789V8.27939H7.27406C7.03119 8.27939 6.79827 8.37587 6.62653 8.54761C6.45479 8.71934 6.35831 8.95227 6.35831 9.19514C6.35831 9.43801 6.45479 9.67094 6.62653 9.84267C6.79827 10.0144 7.03119 10.1109 7.27406 10.1109H9.10556V11.9424C9.10556 12.1853 9.20204 12.4182 9.37378 12.5899C9.54552 12.7617 9.77844 12.8581 10.0213 12.8581C10.2642 12.8581 10.4971 12.7617 10.6688 12.5899C10.8406 12.4182 10.9371 12.1853 10.9371 11.9424V10.1109H12.7686C13.0114 10.1109 13.2444 10.0144 13.4161 9.84267C13.5878 9.67094 13.6843 9.43801 13.6843 9.19514C13.6843 8.95227 13.5878 8.71934 13.4161 8.54761C13.2444 8.37587 13.0114 8.27939 12.7686 8.27939H10.9371V6.44789Z"
            fill="currentColor"
        />
    </svg>
</button>
        </div>
    </div>
</div>